import { render, staticRenderFns } from "./DetailsCycles.vue?vue&type=template&id=61d6091e&scoped=true&"
import script from "./DetailsCycles.vue?vue&type=script&lang=js&"
export * from "./DetailsCycles.vue?vue&type=script&lang=js&"
import style0 from "./DetailsCycles.vue?vue&type=style&index=0&id=61d6091e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6091e",
  null
  
)

export default component.exports